import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import DateIcon from "@material-ui/icons/ScheduleOutlined";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import StarsIcon from "@material-ui/icons/Stars";
import StarRateIcon from "@material-ui/icons/StarRate";
import FilterListIcon from "@material-ui/icons/FilterList";
import { lighten } from "@material-ui/core/styles/colorManipulator";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import EditExistingWordDialog from "../dashboard/EditExistingWordDialog";

import { SpeakText } from "./Speak";
import WordSummary from "./WordSummary";
import "./EnhancedTable.css";

let counter = 0;
let filter_bookmark = false;

let open = false;

function createData(name, calories, fat, carbs, protein) {
  counter += 1;
  return { id: counter, name, calories, fat, carbs, protein };
}

function desc(a, b, orderBy) {
  if (typeof b[orderBy] === "string" || b[orderBy] instanceof String) {
    if (b[orderBy].toUpperCase() < a[orderBy].toUpperCase()) {
      return -1;
    }
    if (b[orderBy].toUpperCase() > a[orderBy].toUpperCase()) {
      return 1;
    }
  } else {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  }

  return 0;
}

function stableSort(array, cmp) {
  //  alert(cmp);
  // console.log(cmp);
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    //  console.log(a);
    //  console.log(b);
    if (order !== 0) return order;

    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  //  alert(order);
  // alert(orderBy);
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const rows = [
  { id: "change", numeric: false, disablePadding: true, label: "" },
  { id: "createdAt", numeric: false, disablePadding: true, label: "createdAt" },
  {
    id: "Language2",
    numeric: false,
    disablePadding: false,
    label: "Language2",
  },
  {
    id: "Language3",
    numeric: false,
    disablePadding: false,
    label: "Language3",
  },
  {
    id: "Language1",
    numeric: false,
    disablePadding: false,
    label: "Language1",
  },
  {
    id: "Language4",
    numeric: false,
    disablePadding: false,
    label: "Language4",
  },
  // {
  //   id: "Description1",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Description1",
  // },
];

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } =
      this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount && rowCount > 0}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {rows.map(
            (row) => (
              <TableCell
                key={row.id}
                align={row.numeric ? "right" : "left"}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
});

let EnhancedTableToolbar = (props) => {
  const { numSelected, classes, editWord } = props;

  function handleEditButton() {
    props.editWord("155");
  }

  function handleFilterBookmarkButton() {
    props.filterBookmark();
  }
  function BookmarkItems(selected_option) {
    props.BookmarkItems(selected_option);
  }
  function DeleteItems(selected_option) {
    props.DeleteItems(selected_option);
  }

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Edit
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 && (
          <Tooltip title="Un-Bookmark">
            <IconButton onClick={() => BookmarkItems(false)} aria-label="Edit">
              <StarRateIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton onClick={() => DeleteItems()} aria-label="Delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <div>
            <Tooltip title="Filter list">
              <IconButton aria-label="Filter list">
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </div>
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Edit">
            <IconButton onClick={() => handleEditButton()} aria-label="Edit">
              <EditIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton
              onClick={() => handleFilterBookmarkButton()}
              aria-label="Filter list"
            >
              <StarsIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className={classes.actions}>
        {numSelected > 0 && (
          <Tooltip title="Bookmark">
            <IconButton onClick={() => BookmarkItems(true)} aria-label="Edit">
              <StarsIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  editWord: PropTypes.func.isRequired,
  filterBookmark: PropTypes.func.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
});

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.handleButtonPress = this.handleButtonPress.bind(this);
    this.handleButtonRelease = this.handleButtonRelease.bind(this);
  }
  state = {
    order: "desc",
    orderBy: "createdAt",
    selected: [],
    data: [
      createData("Cupcake", 305, 3.7, 67, 4.3),
      createData("Donut", 452, 25.0, 51, 4.9),
      createData("Eclair", 262, 16.0, 24, 6.0),
      createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
      createData("Gingerbread", 356, 16.0, 49, 3.9),
      createData("Honeycomb", 408, 3.2, 87, 6.5),
      createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
      createData("Jelly Bean", 375, 0.0, 94, 0.0),
      createData("KitKat", 518, 26.0, 65, 7.0),
      createData("Lollipop", 392, 0.2, 98, 0.0),
      createData("Marshmallow", 318, 0, 81, 2.0),
      createData("Nougat", 360, 19.0, 9, 37.0),
      createData("Oreo", 437, 18.0, 63, 4.0),
    ],
    page: 0,
    rowsPerPage: 200,
    words: [],
    sets: [],
    open: false,

    showLanguage1: true,
    showLanguage2: true,
    showLanguage3: true,
    showLanguage4: true,
    showLanguage5: true,

    showDescription1: false,
    showDescription2: false,
    showDescription3: false,
    showDescription4: false,
    showDescription5: false,
  };
  // words: [{id:"1",Language1:"erer",Language2:"erre",Language3:"",Description1:"",Description2:""}]
  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.words.map((n) => n.id) }));
      console.log(this.state.selected);
      return;
    }
    this.setState({ selected: [] });
  };

  handleRowClick = (event, id, text_speak) => {
    console.log(event);
    console.log(id);
    // this.state.words[0].Language1 = "bla";
    // this.setState({ showDescription1: !this.state.showDescription1 });
    const testElements = document.getElementsByClassName(id);
    console.log(testElements);

    //element.classList.contains(class);
    Array.prototype.forEach.call(testElements, function (el) {
      // Do stuff here
      if (el.classList.contains("hidden")) {
        el.classList.remove("hidden");
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
        el.classList.add("hidden");
      }

      //  console.log(el.tagName);
    });
    // testElements.forEach((e) => {
    //   e.classList.add("visible");
    // });
  };

  handleClick = (event, id, text_speak) => {
    //  alert("select1");
    //@mario
    //SpeakText(text_speak);
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    //alert(id);
    this.setState({ selected: newSelected });
    this.props.handleSelectedItemsChanged(newSelected);
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleEditWord = (id) => {
    var id_temp = this.state.selected.toString().trim();
    //"ndjS7iLq8ky1iWIMC9CP"
    var word_temp = this.state.words.find((word) => word.id === id_temp);
    this.setState({
      open: true,
      word: word_temp,
    });
    // this.props.RedirectEdit(this.state.selected[0]);
  };

  handleBookmarkFilter = () => {
    if (filter_bookmark) {
      filter_bookmark = false;
    } else {
      filter_bookmark = true;
    }

    this.props.BookmarkFilter(filter_bookmark);
  };
  BookmarkItems = (selected_option) => {
    this.props.BookmarkItems(this.state.selected, selected_option);
  };
  DeleteItems = (selected_option) => {
    this.props.DeleteItems(this.state.selected);
  };

  handleClose(save) {
    this.setState({
      open: false,
    });
    if (save) {
      this.props.RefreshFromDatabase();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      words: nextProps.words,
      sets: nextProps.sets,
      word: {},
      selected: [],
    });
    // You don't have to do this check first, but it can help prevent an unneeded render
    // if (nextProps.startTime !== this.state.startTime) {
    //     alert("call");
    //   this.setState({ words: nextProps.props.words });

    // }
    // alert("props");
  }

  //hold press event mario https://stackoverflow.com/questions/48048957/react-long-press-event
  handleButtonPress(text_speak) {
    //speak commented
    //   this.buttonPressTimer = setTimeout(() => SpeakText(text_speak), 700);
  }

  handleButtonRelease() {
    clearTimeout(this.buttonPressTimer);
  }

  render() {
    const { classes } = this.props;

    const { data, order, orderBy, selected, rowsPerPage, page, words } =
      this.state;

    let emptyRows = 0;
    let wordslenght = 0;
    let count = 0;

    if (typeof words != "undefined") {
      emptyRows =
        rowsPerPage - Math.min(rowsPerPage, words.length - page * rowsPerPage);
      wordslenght = words.length;
    }

    return (
      <div>
        <EnhancedTableToolbar
          numSelected={selected.length}
          editWord={this.handleEditWord}
          filterBookmark={this.handleBookmarkFilter}
          BookmarkItems={this.BookmarkItems}
          DeleteItems={this.DeleteItems}
        />
        <div className={classes.tableWrapper + " my-table"}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={wordslenght}
            />
            <TableBody>
              {typeof words != "undefined" &&
                stableSort(words, getSorting(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((n) => {
                    var date = new Date(n.createdAt.seconds * 1000);
                    var year = date.getFullYear();
                    var month = date.getMonth();
                    var day = date.getDate();
                    // Hours part from the timestamp
                    var hours = date.getHours();
                    // Minutes part from the timestamp
                    var minutes = "0" + date.getMinutes();
                    // Seconds part from the timestamp
                    var seconds = "0" + date.getSeconds();

                    // Will display time in 10:30:23 format
                    var formattedTime =
                      day +
                      "." +
                      month +
                      "." +
                      year +
                      "_" +
                      hours +
                      ":" +
                      minutes.substr(-2) +
                      ":" +
                      seconds.substr(-2);
                    count++;
                    const isSelected = this.isSelected(n.id);
                    return (
                      <TableRow
                        onClick={(event) =>
                          this.handleRowClick(event, n.id, n.Language1)
                        }
                        hover
                        // onClick={(event) =>
                        //   //    this.handleClick(event, n.id, n.Language1)
                        //  // this.handleRowClick(event, n.id, n.Language1)
                        // }
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.id}
                        selected={isSelected}
                        onTouchStart={() =>
                          this.handleButtonPress(n.Description1)
                        }
                        onTouchEnd={this.handleButtonRelease}
                        onMouseDown={() =>
                          this.handleButtonPress(n.Description1)
                        }
                        onMouseUp={this.handleButtonRelease}
                        onMouseLeave={this.handleButtonRelease}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            onClick={(event) =>
                              this.handleClick(event, n.id, n.Language1)
                            }
                            checked={isSelected}
                          />
                        </TableCell>
                        <TableCell padding="checkbox">
                          <IconButton
                            onClick={() => this.props.ChangeDate(n.id)}
                            aria-label="Share"
                          >
                            <DateIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {formattedTime}
                        </TableCell>

                        <TableCell align="right">
                          {n.Language2}
                          <div className={"hidden " + n.id}>
                            {n.Description2}
                          </div>
                        </TableCell>

                        <TableCell align="right">
                          {n.Language3}
                          <div className={"hidden " + n.id}>
                            {n.Description3}
                          </div>
                        </TableCell>
                        <TableCell align="right">
                          {n.Language1}
                          <div className={"hidden " + n.id}>
                            {n.Description1}
                          </div>
                        </TableCell>
                        <TableCell align="right">
                          {n.Language4}
                          <div className={"hidden " + n.id}>
                            {n.Description4}
                          </div>
                        </TableCell>
                        {/* {this.state.showDescription1 && (
                          <TableCell align="right">{n.Description1}</TableCell>
                        )} */}
                      </TableRow>
                    );
                  })}

              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[200, 300]}
          component="div"
          count={wordslenght}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />

        <Dialog
          open={this.state.open}
          onClose={() => this.handleClose(false)}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">
            Editar una nueva oración
          </DialogTitle>
          <DialogContent>
            <EditExistingWordDialog
              word={this.state.word}
              sets={this.state.sets}
              handleClose={() => this.handleClose(true)}
              collection_name={this.props.collection_name}
            ></EditExistingWordDialog>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnhancedTable);
